var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveFast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.05382 13.2778H2.77604M5.10938 9H1.60938M7.05382 4.72222H3.16493M13.276 2L8.14548 9.18278C7.9184 9.5007 7.80486 9.65966 7.80977 9.79219C7.81405 9.90757 7.86938 10.0151 7.96079 10.0856C8.06577 10.1667 8.26112 10.1667 8.6518 10.1667H12.4983L11.7205 16L16.851 8.81722C17.0781 8.4993 17.1917 8.34034 17.1868 8.20781C17.1825 8.09243 17.1271 7.98491 17.0357 7.91436C16.9308 7.83333 16.7354 7.83333 16.3447 7.83333H12.4983L13.276 2Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveFast);
export default __webpack_public_path__ + "static/media/inactive-fast.b7e74d56017b831b399d3040c4757258.svg";
export { ForwardRef as ReactComponent };